<script type="text/jsx">
    import Vue from 'vue'
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    export default {
        name: 'inscription-handling',
        created: function () {
            Event.$on('addLetter', this.onAddLetter);
        },
        beforeDestroy: function () {
            Event.$off('addLetter', this.onAddLetter);
        },
        methods: {
            updateInscription: function (data) {
                if ('id' in data && 'text' in data) {
                    var parts = ('' + data.id).split('-', 2); // eq. l-1
                    if (parts.length == 2) {
                        var lineIndex = +parts[1] - 1;
                        Vue.set(this.lines, lineIndex, data.text);
                    }
                }
            },
            onAddLetter: function (data) {
                if ('id' in data ) {
                    var parts = ('' + data.id).split('-', 2); // eq. l-1
                    if (parts.length == 2) {
                        var lineIndex = +parts[1] - 1;
                        var text = false;
                        if ('letter' in data) {
                            var newText = (this.lines[lineIndex] || '') + data.letter;
                            if (newText.length <= this.product.max_characters) {
                                text = newText;
                            }
                        } else if ('action' in data && data.action === 'clear') {
                            text = ''; // clear all
                        }
                        if (text !== false) {
                            Vue.set(this.lines, lineIndex, text);
                        }
                    }
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// inscription-handling.vue?0436a5bf